"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NicheFormEngine = _interopRequireDefault(require("../../common/NicheFormEngine"));
var _nicheUserFeService = require("niche-user-fe-service");
var _constants = require("../../common/constants");
var _antd = require("antd");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NicheForgotPassword = props => {
  const [error, setError] = (0, _react.useState)("");
  const [success, setSuccess] = (0, _react.useState)("");
  const [submitting, setSubmitting] = (0, _react.useState)(false);
  const {
    token: {
      colorError
    }
  } = _antd.theme.useToken();
  const schema = {
    type: "object",
    properties: {
      email: {
        type: "string",
        format: "email"
      }
    }
  };
  const uiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: submitting,
        type: "primary",
        block: true,
        size: "large",
        className: "btn btn-warning" + (submitting ? " btn-disabled" : "")
      },
      submitText: submitting ? _constants.formConstants.buttons.SENDING : _constants.formConstants.buttons.SEND
    },
    email: {
      "ui:options": {
        label: false,
        placeholder: _constants.formConstants.requiredFields.EMAIL
      }
    }
  };
  const handleForgotPassword = async (url, payload) => {
    setSubmitting(true);
    await (0, _nicheUserFeService.jwtResetPassword)(url, payload).then(response => {
      props.handleSubmit(response);
      setSuccess(response?.data?.message);
      setError("");
      setSubmitting(false);
    }).catch(err => {
      setError(err?.response?.data?.error || err?.response?.data?.message);
      setSuccess("");
      setSubmitting(false);
    });
  };
  const onSubmit = data => {
    if (!data?.formData?.email) {
      setError(_constants.formConstants.validations.BLANK_EMAIL);
    } else {
      setError("");
      handleForgotPassword(props.url, data?.formData?.email);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        color: colorError
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: error
      })
    }), success && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "success",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: success
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NicheFormEngine.default, {
      schema: schema,
      uiSchema: uiSchema,
      clearError: () => setError(""),
      handleSubmit: onSubmit
    })]
  });
};
var _default = exports.default = NicheForgotPassword;